export const trackSliderClick = (url: string, header: string): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'slider_click', {
      event_category: 'Slider click',
      link_url: url,
      slide_title: header,
      value: 1,
    });
  }
};
